import React, { useState } from "react";

import { FormControl } from "baseui/form-control";
import { Input } from "baseui/input";
import { useLicense } from "../contexts/LicenseContext";
import { Button } from "baseui/button";
import { H4, ParagraphSmall, Paragraph2 } from "baseui/typography";
import { Notification } from "baseui/notification";
import { Grid, Cell } from "baseui/layout-grid";
import { Block } from "baseui/block";
import { ArrowRight, Check } from "baseui/icon";
import { Card, StyledBody, StyledAction } from "baseui/card";
import { Tag, KIND } from "baseui/tag";
import { OfficialLinks } from "../components/OfficialLinks";

export function InvalidLicenseBox() {
  const [value, setValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const { validate, valid } = useLicense();

  async function handleSubmit(e) {
    e.preventDefault();
    setIsLoading(true);
    await validate(value);
    setIsLoading(false);
  }

  const benefits = [
    "Unlimited imports",
    "Unlimited boards",
    "Unlimited cards import",
    "Import from Excel or CSV",
    "Map cards fields with source file columns",
    "Choose where imported cards should be added",
  ];

  return (
    <Grid gridMargins={0}>
      <Cell span={[6, 4]}>
        <H4 marginTop="12px" marginBottom={0}>
          {process.env.REACT_APP_PRODUCT_NAME}
        </H4>
        <Block>
          <ParagraphSmall>
            To use Smart Import you need a valid license key. If you do have one
            enter it below.
          </ParagraphSmall>
          {!valid && (
            <Notification
              overrides={{
                Body: {
                  style: {
                    boxSizing: "border-box",
                    width: "100%",
                  },
                },
              }}
              kind="negative"
            >
              The license key is invalid or the license has expired.
            </Notification>
          )}
          <form onSubmit={handleSubmit}>
            <FormControl>
              <Input
                value={value}
                required
                onChange={(e) => setValue(e.target.value)}
                placeholder="Enter your license key"
              />
            </FormControl>
            <Button isLoading={isLoading} type="submit">
              Apply
            </Button>
          </form>
          <OfficialLinks />
        </Block>
      </Cell>
      <Cell span={[6, 4]}>
        <Block paddingTop="60px">
          <Card
            overrides={{
              Action: { style: { paddingTop: "48px" } },
            }}
          >
            <StyledBody align="center">
              <H4 marginTop={0} marginBottom="8px">
                Buy new license
              </H4>
              <Tag
                closeable={false}
                variant="solid"
                kind={KIND.blue}
                size="medium"
                overrides={{
                  Root: { style: { marginBottom: "24px" } },
                  Text: { style: { maxWidth: "auto" } },
                }}
              >
                $6/month or $24/year per user
              </Tag>
              {benefits.map((text, index) => (
                <Paragraph2 marginTop="4px" marginBottom={0} key={index}>
                  <Check
                    size={24}
                    overrides={{
                      Svg: { style: { verticalAlign: "bottom" } },
                    }}
                  />{" "}
                  {text}
                </Paragraph2>
              ))}
            </StyledBody>
            <StyledAction align="center">
              <Button
                endEnhancer={() => <ArrowRight size={24} />}
                shape="pill"
                $as="a"
                href={`${process.env.REACT_APP_LICENSE_MANAGER_URL}/checkout`}
                target="_blank"
              >
                Continue purchase
              </Button>
            </StyledAction>
          </Card>
        </Block>
      </Cell>
    </Grid>
  );
}
